import {Model} from "../model";

export class OperationStatus implements Model {
  id: string;
  loading: Promise<Model> | undefined;
  status: string;
}
